
import Vue from 'vue'

export default Vue.extend({
  name: 'SearchForm',
  model: {
    prop: 'searchString',
    event: 'change'
  },
  props: {
    searchString: {
      type: String,
      required: true,
      default: ''
    }
  },
  computed: {
    searchStringModel: {
      get: function () {
        return this.searchString
      },
      set: function (nV: string) {
        this.$emit('change', nV)
      }
    }
  },
  mounted () {
    this.$refs.inputSearch?.focus()
  },
  methods: {
    clearSearchString () {
      this.searchStringModel = ''
      this.$emit('clear')
    }
  }
})
